import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { template: String }

  visit(event) {
    const id = event.currentTarget.value
    if (!id) return

    window.location.href = this.templateValue.replace("__UID__", id)
  }
}
